import React from "react";
import { intakeBrand } from "../../config/practice";

// departmentid: the intake's location (PatientOnboarding's route); it names
// CODE on /onboard-code and C-HIM everywhere else (config/practice.js
// intakeBrand). Callers that pass none get C-HIM's text, as before.
const DisclaimerModal = ({ open, onAgree, onDisagree, departmentid }) => {
  if (!open) return null;
  const brand = intakeBrand(departmentid);

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] px-3">
      <div className="bg-white text-start rounded-xl shadow-2xl w-full max-w-xl p-6 animate-fadeIn">
        
        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          New Patient Disclaimer
        </h2>

        {/* Content */}
        <div className="space-y-4 max-h-[300px] overflow-y-auto pr-2 text-gray-700 leading-relaxed">

          <ul className="list-disc pl-5 space-y-3">
            <li>
              <strong>Medical Information:</strong>  
              Please provide accurate and complete details to help us understand your health history. Incorrect information may affect your treatment plan.
            </li>

            <li>
              <strong>Confidentiality:</strong>  
              Your information is protected under HIPAA and shared only with authorized healthcare professionals.
            </li>

            <li>
              <strong>Consent for Treatment:</strong>  
              By continuing, you agree to undergo evaluation and treatment at the {brand.name}.
            </li>

            <li>
              <strong>Insurance & Billing:</strong>  
              Completing this form does not guarantee insurance approval. Co-pays or uncovered services may apply.
            </li>

            <li>
              <strong>Emergency Care:</strong>  
              This form is not for emergencies. Call 911 immediately for urgent medical issues.
            </li>
          </ul>

          <p className="font-medium">
            By clicking <span className="text-blue-600">“I Agree”</span>, you acknowledge that you have read and understood the above details.
          </p>
        </div>

        {/* Buttons */}
       <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6 w-full">
  <button
    onClick={onDisagree}
    className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 
               text-gray-700 font-medium transition w-full sm:w-auto"
  >
    I Don't Agree
  </button>

  <button
    onClick={onAgree}
    className="px-5 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 
               text-white font-medium transition w-full sm:w-auto"
  >
    I Agree
  </button>
</div>

      </div>
    </div>
  );
};

export default DisclaimerModal;
